import { Close } from "@mui/icons-material";
import { Box, IconButton, TextField, InputAdornment } from "@mui/material";
import { EntitySelector } from "modals/EntitySelector";
import { FC, useState } from "react";
import { useVoiceFieldFocus } from "hooks/useVoiceFieldFocus";

type FieldWithEntitySelectorProps = {
  label?: string;
  element: any;
  onChangeElement: (value: any) => void;
  idField: string;
  entityName: string;
  entityList: any[];
  displayField?: string;
  error?: string;
  compact?: boolean;
  disabled?: boolean;
  voiceFieldId?: string;
};

export const FieldWithEntitySelector: FC<FieldWithEntitySelectorProps> = ({
  label,
  element,
  onChangeElement,
  idField,
  entityName,
  entityList,
  displayField = "name",
  error = "",
  disabled = false,
  voiceFieldId,
}) => {
  const [openEntitySelector, setOpenEntitySelector] = useState<boolean>(false);
  const { activeFieldId } = useVoiceFieldFocus();
  const voiceOpen = Boolean(voiceFieldId && activeFieldId === voiceFieldId);
  const selectorOpen = openEntitySelector || voiceOpen;

  return (
    <Box>
      <TextField
        disabled={disabled}
        label={label}
        fullWidth
        placeholder={`Select ${entityName}`}
        value={element ? element[displayField] : ""}
        onClick={() => setOpenEntitySelector(true)}
        size="small"
        margin="dense"
        sx={{
          cursor: "pointer",
          "& .MuiInputBase-input": {
            cursor: "pointer",
          },
        }}
        slotProps={{
          input: {
            readOnly: true,
            endAdornment: element && (
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  aria-label="clear"
                  onClick={(e) => {
                    e.stopPropagation();
                    onChangeElement(null);
                  }}
                  size="small"
                >
                  <Close />
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
        error={error !== ""}
        helperText={error}
      />

      {selectorOpen && (
        <EntitySelector
          open={selectorOpen}
          onClose={() => {
            if (!voiceOpen) setOpenEntitySelector(false);
          }}
          title={`Select ${entityName}`}
          filterCriteria={(search, data) =>
            data[displayField].toLowerCase().includes(search.toLowerCase())
          }
          listEntities={Array.isArray(entityList) ? entityList.filter(Boolean) : []}
          onSelect={(selected: any) => {
            onChangeElement(selected);
          }}
          keyField={idField}
          closeOnSelect={!voiceOpen}
          selectedKey={element?.[idField]}
          lockOpen={voiceOpen}
        />
      )}
    </Box>
  );
};
